import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  key: 0,
  class: "card-title m-0"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = {
  key: 0,
  class: "col-lg-4 fv-row fv-plugins-icon-container"
}
const _hoisted_36 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_40 = { class: "dialog-footer" }
const _hoisted_41 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_42 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_59 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "row mb-6" }
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = { class: "card mb-5 mb-xl-10" }
const _hoisted_69 = { class: "card-header border-0" }
const _hoisted_70 = { class: "card-title m-0" }
const _hoisted_71 = { class: "fw-bolder m-0" }
const _hoisted_72 = { class: "collapse show" }
const _hoisted_73 = { class: "card-body border-top p-9" }
const _hoisted_74 = { class: "row mb-6" }
const _hoisted_75 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_76 = { class: "col-lg-8 fv-row" }
const _hoisted_77 = { class: "row mb-6" }
const _hoisted_78 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_79 = { class: "col-lg-8 fv-row" }
const _hoisted_80 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_81 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_82 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_89 = { class: "row mb-6" }
const _hoisted_90 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_91 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_92 = { class: "row mb-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_94 = { class: "card mb-5 mb-xl-10" }
const _hoisted_95 = { class: "card-header border-0" }
const _hoisted_96 = { class: "card-title m-0" }
const _hoisted_97 = { class: "fw-bolder m-0" }
const _hoisted_98 = { class: "collapse show" }
const _hoisted_99 = { class: "card-body border-top p-9" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "row mb-6" }
const _hoisted_102 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_103 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_104 = { class: "row mb-6" }
const _hoisted_105 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_106 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "row mb-6" }
const _hoisted_110 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_111 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_112 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_113 = { class: "row mb-6" }
const _hoisted_114 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_115 = { class: "col-md-4 fv-row fv-plugins-icon-container" }
const _hoisted_116 = { key: 2 }
const _hoisted_117 = { key: 3 }
const _hoisted_118 = { key: 4 }
const _hoisted_119 = { class: "row my-6" }
const _hoisted_120 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_121 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_122 = { class: "row mb-6" }
const _hoisted_123 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_124 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_126 = { key: 5 }
const _hoisted_127 = { class: "row my-6" }
const _hoisted_128 = { class: "d-flex flex-row flex-column-fluid" }
const _hoisted_129 = { class: "d-flex flex-row-fluid flex-center" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_EstadoTag = _resolveComponent("EstadoTag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_FamiliaReadOnly = _resolveComponent("FamiliaReadOnly")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DrawerHorario = _resolveComponent("DrawerHorario")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ProfesionalesTablaDisponibles = _resolveComponent("ProfesionalesTablaDisponibles")!
  const _component_ProfesionalesTablaAsignados = _resolveComponent("ProfesionalesTablaAsignados")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ServicioColectivoPicker = _resolveComponent("ServicioColectivoPicker")!
  const _component_Page = _resolveComponent("Page")!
  const _component_SendEmailModal = _resolveComponent("SendEmailModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        (_ctx.estado !== _ctx.ServicioEstado.aprobado)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              class: "mx-3"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cambiarEstado('pasarAPendiente'))),
                      disabled: _ctx.estado === _ctx.ServicioEstado.pendiente
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.pendiente.button")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cambiarEstado('rechazarSolicitud'))),
                      divided: "",
                      disabled: _ctx.estado === _ctx.ServicioEstado.rechazado
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.rechazar.button")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cambiarEstado('realizadoPorErrorSolicitud'))),
                      disabled: _ctx.estado === _ctx.ServicioEstado.realizadorPorError
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.realizadoPorError.button")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _ctx.eliminar,
                      divided: "",
                      disabled: _ctx.estado === _ctx.ServicioEstado.aprobado
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_el_divider, { class: "my-2" }),
                    _createVNode(_component_el_dropdown_item, {
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#mau_modal_send_email",
                      onClick: _ctx.prepareSendEmail
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.enviarCorreo")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "default" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit,
          loading: _ctx.crearServicioProgramado
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("listados.familiaDetalle.guardar.button")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
          type: "border-card",
          onTabClick: _ctx.tabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.servicioDetalle.datosSolicitanteGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.servicioDetalle.datosSolitudDeServicio")), 1)
                    ]),
                    (_ctx.estado)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_EstadoTag, { estado: _ctx.estado }, null, 8, ["estado"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_select, {
                            name: "tratamiento",
                            class: "w-100",
                            modelValue: _ctx.tratamiento,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tratamiento) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tratamiento.text,
                                  value: tratamiento.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.servicioDetalle.menor.nombreMenor")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "nombre",
                                placeholder: " ",
                                modelValue: _ctx.nombre,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nombre) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_ErrorMessage, { name: "nombre" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "apellidos",
                                placeholder: " ",
                                modelValue: _ctx.apellidos,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.apellidos) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_ErrorMessage, { name: "apellidos" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.fechaNacimiento.label")), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_el_date_picker, {
                            format: "DD/MM/YYYY",
                            name: "fechaNacimiento",
                            modelValue: _ctx.fechaNacimiento,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                            type: "date",
                            class: "w-100"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_ErrorMessage, { name: "fechaNacimiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("listados.servicioDetalle.lugarPrestacion.label")), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_el_select, {
                                name: "lugarPrestacion",
                                modelValue: _ctx.lugarPrestacion,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lugarPrestacion) = $event)),
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lugaresPrestacion, (lugar, i) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      value: lugar.id,
                                      label: lugar.nombre,
                                      key: i
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_ErrorMessage, { name: "lugarPrestacion" })
                                ])
                              ])
                            ]),
                            (_ctx.estado === 'PENDIENTE')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.openServicioColectivoPicker,
                                    loading: _ctx.crearServicioProgramado,
                                    disabled: _ctx.lugarPrestacion !== 'ESPACIO'
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.button")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "loading", "disabled"]),
                                  _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
                                    modelValue: _ctx.dialogVisible,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogVisible) = $event)),
                                    title: _ctx.$t('dialogs.reasignarAServicioColectivo.title')
                                  }, {
                                    footer: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_40, [
                                        _createVNode(_component_el_button, { onClick: _ctx.closeServicioColectivoPicker }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(
                                "dialogs.reasignarAServicioColectivo.cancelButton"
                              )), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _ctx.asignarServicioColectivo,
                                          disabled: !_ctx.dialogSelected
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(
                                  "dialogs.reasignarAServicioColectivo.okButton"
                                )), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick", "disabled"])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.texto")), 1),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _createElementVNode("div", _hoisted_39, [
                                            _createVNode(_component_el_select, {
                                              modelValue: _ctx.dialogSelected,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogSelected) = $event)),
                                              class: "w-100",
                                              placeholder: 
                                  _ctx.$t(
                                    'dialogs.reasignarAServicioColectivo.placeholder'
                                  )
                                ,
                                              "no-data-text": 
                                  _ctx.$t(
                                    'dialogs.reasignarAServicioColectivo.sinServiciosColectivos'
                                  )
                                ,
                                              "popper-class": "w-auto"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogData, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.id,
                                                    label: item.nombre,
                                                    value: item.id
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.nombre), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "placeholder", "no-data-text"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "title"])), [
                                    [_directive_loading, _ctx.dialogLoading]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.lugarPrestacion == 'ESPACIO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("listados.servicioDetalle.lugarEspacioColectivo.label")), 1),
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_el_select, {
                                name: "lugarEspacioColectivo",
                                modelValue: _ctx.lugarEspacioColectivo,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.lugarEspacioColectivo) = $event)),
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lugaresEspaciosColectivos, (lugarColectivo, i) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      value: lugarColectivo.id,
                                      label: lugarColectivo.nombre,
                                      key: i
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(lugarColectivo.nombre), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "lugarEspacioColectivo",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.lugarEspacioColectivo == 'OTROS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("listados.servicioDetalle.otrosEspacioColectivo.label")), 1),
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_el_input, {
                                name: "otrosEspacioColectivo",
                                modelValue: _ctx.otrosEspacioColectivo,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.otrosEspacioColectivo) = $event)),
                                type: "text",
                                placeholder: " "
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "otrosEspacioColectivo",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("formularios.servicioDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "direccion",
                            placeholder: " ",
                            modelValue: _ctx.direccion,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.direccion) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_50
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_ErrorMessage, { name: "direccion" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("formularios.servicioDetalle.ubicacion.label")), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_el_select, {
                            disabled: "",
                            name: "comarcaId",
                            modelValue: _ctx.comarcaId,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.comarcaId) = $event)),
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.nombreCompuesto,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_ErrorMessage, { name: "comarca" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.proyectosN2.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("formularios.servicioDetalle.proyectoN2.label")), 1),
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_el_select, {
                                name: "proyectoId",
                                modelValue: _ctx.proyectoId,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.proyectoId) = $event)),
                                class: "w-100",
                                clearable: "",
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proyectosN2, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.denominacion,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_ErrorMessage, { name: "proyectoId" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t(
                      "formularios.servicioDetalle.menor.detalleNecesidades.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.descripcion,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.descripcion) = $event)),
                            rows: 3,
                            autosize: { minRows: 2 },
                            type: "textarea",
                            placeholder: " "
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(_component_ErrorMessage, { name: "descripcion" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.familia)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: _ctx.$t('formularios.servicioDetalle.datosFamilia')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FamiliaReadOnly, { familia: _ctx.familia }, null, 8, ["familia"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.servicioDetalle.fechasServicio')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("h3", _hoisted_71, _toDisplayString(_ctx.$t("formularios.servicioDetalle.fechasHorariosDeServicio")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t(
                      "formularios.servicioDetalle.menor.fechasPrevistas.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_76, [
                          _createVNode(_component_el_date_picker, {
                            format: "DD/MM/YYYY",
                            modelValue: _ctx.fechasPrevistas,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fechasPrevistas) = $event)),
                            type: "daterange",
                            "range-separator": "a",
                            class: "w-100"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t("formularios.servicioDetalle.menor.diasHoras.label")), 1),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("ul", _hoisted_80, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiempos, (tiempo, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "row"
                              }, [
                                _createElementVNode("div", _hoisted_81, [
                                  _createVNode(_component_el_select, {
                                    modelValue: tiempo.dias,
                                    "onUpdate:modelValue": ($event: any) => ((tiempo.dias) = $event),
                                    class: "w-100",
                                    multiple: "",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.dias.label')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dias, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createVNode(_component_el_select, {
                                    modelValue: tiempo.horas,
                                    "onUpdate:modelValue": ($event: any) => ((tiempo.horas) = $event),
                                    class: "w-100",
                                    multiple: "",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.horarios.label')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarios, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeHorario(i))
                                }, _hoisted_85, 8, _hoisted_83)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_component_ErrorMessage, { name: "tiempos" })
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addHorario && _ctx.addHorario(...args)))
                          }, [
                            _hoisted_88,
                            _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.servicioDetalle.menor.diasHoras.añadirHorario"
                      )), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.generarFechas
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.fechas.length > 0
                          ? _ctx.$t(
                              "formularios.servicioDetalle.reconfigurarFechas.button"
                            )
                          : _ctx.$t(
                              "formularios.servicioDetalle.generarFechas.button"
                            )), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              disabled: !_ctx.fechasModificadas,
                              type: "primary",
                              onClick: _ctx.onSubmit,
                              loading: _ctx.crearServicioProgramado
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("listados.familiaDetalle.guardar.button")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick", "loading"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createVNode(_component_el_table, {
                          data: _ctx.fechas,
                          style: {"width":"100%"},
                          stripe: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "fechaToShow",
                              label: _ctx.$t('formularios.servicioDetalle.cabecera.fecha')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "diaSemana",
                              label: 
                      _ctx.$t('formularios.servicioDetalle.cabecera.diaSemana')
                    
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              prop: "hora",
                              label: _ctx.$t('formularios.servicioDetalle.cabecera.hora')
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, { width: "120" }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_el_button, {
                                  type: "text",
                                  onClick: ($event: any) => (_ctx.borrarFecha(scope.$index))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.borrar.button")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.drawer = true))
                      }, [
                        _hoisted_93,
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.menor.diasHoras.añadirFecha")), 1)
                      ]),
                      _createVNode(_component_DrawerHorario, {
                        onAceptar: _ctx.drawerAceptar,
                        cerrar: _ctx.drawerCerrar,
                        display: _ctx.drawer,
                        "before-close": _ctx.drawerCerrar
                      }, null, 8, ["onAceptar", "cerrar", "display", "before-close"])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              disabled: !_ctx.enableTabProfesional,
              label: _ctx.$t('formularios.servicioDetalle.profesionales'),
              name: "profesionales"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.$t("formularios.servicioDetalle.profesionalesAsignados", {
                    inicioPrevisto: _ctx.inicioPrevistoFormateado,
                    finPrevisto: _ctx.finPrevistoFormateado,
                  })), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      (!_ctx.busquedaProfesional && !_ctx.profesionalesAsignados)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.servicioSinAsignar.label"
                          )), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary text-uppercase mb-5",
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.busquedaProfesional = true))
                                  }, [
                                    _hoisted_107,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.buscarProfesional.button"
                          )), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.busquedaProfesional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("div", _hoisted_110, [
                                _createVNode(_component_el_select, {
                                  name: "vehiculoPropio",
                                  clearable: "",
                                  modelValue: _ctx.vehiculoPropio,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.vehiculoPropio) = $event)),
                                  placeholder: 
                        _ctx.$t('formularios.servicioDetalle.vehiculoPropio.label')
                      ,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiculos, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.nombre,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.idioma,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.idioma) = $event)),
                                  clearable: "",
                                  multiple: "",
                                  placeholder: 
                        _ctx.$t('formularios.servicioDetalle.idiomas.label')
                      ,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nombreIdioma, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_112, [
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: 
                        _ctx.$t(
                          'formularios.servicioDetalle.disponeTitulacion.tooltip'
                        )
                      ,
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.disponeTitulacion,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.disponeTitulacion) = $event)),
                                      clearable: "",
                                      placeholder: 
                          _ctx.$t('formularios.servicioDetalle.titulacion.label')
                        ,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          key: "true",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.titulacion.opcionSi'
                            )
                          ,
                                          value: true
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          key: "false",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.titulacion.opcionNo'
                            )
                          ,
                                          value: false
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["content"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.experienciaCuidadoMenores,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.experienciaCuidadoMenores) = $event)),
                                  clearable: "",
                                  placeholder: 
                        _ctx.$t(
                          'formularios.servicioDetalle.experienciaCuidadoMenores.label'
                        )
                      ,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: "EXPERIENCIAPROFESIONAL",
                                      label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.EXPERIENCIAPROFESIONAL'
                          )
                        
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "EXPERIENCIANOPROFESIONAL",
                                      label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.EXPERIENCIANOPROFESIONAL'
                          )
                        
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_el_option, {
                                      value: "SINEXPERIENCIA",
                                      label: 
                          _ctx.$t(
                            'formularios.servicioDetalle.experienciaCuidadoMenores.SINEXPERIENCIA'
                          )
                        
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "dark",
                                  content: 
                        _ctx.$t(
                          'formularios.servicioDetalle.disponiblidadEspecial.tooltip'
                        )
                      ,
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.disponiblidadEspecial,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.disponiblidadEspecial) = $event)),
                                      clearable: "",
                                      multiple: "",
                                      placeholder: 
                          _ctx.$t('formularios.servicioDetalle.disponibilidad.label')
                        ,
                                      style: {"width":"100%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          key: "laborables",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.laborables'
                            )
                          ,
                                          value: "laborables"
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          key: "finesDeSemana",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.finesDeSemana'
                            )
                          ,
                                          value: "finesDeSemana"
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          key: "festivos",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.festivos'
                            )
                          ,
                                          value: "festivos"
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          key: "noches",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.noches'
                            )
                          ,
                                          value: "noches"
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_el_option, {
                                          key: "urgencias",
                                          label: 
                            _ctx.$t(
                              'formularios.servicioDetalle.disponibilidad.urgencias'
                            )
                          ,
                                          value: "urgencias"
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _: 1
                                }, 8, ["content"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.busquedaProfesional && _ctx.profesionalesFiltrados)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                            _createVNode(_component_ProfesionalesTablaDisponibles, {
                              profesionales: _ctx.profesionalesFiltrados,
                              inicioPrevisto: _ctx.inicioPrevisto,
                              finPrevisto: _ctx.finPrevisto,
                              comarcaId: _ctx.comarcaId
                            }, null, 8, ["profesionales", "inicioPrevisto", "finPrevisto", "comarcaId"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                  !_ctx.busquedaProfesional &&
                  _ctx.profesionalesAsignadosFilas &&
                  _ctx.profesionalesAsignados
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createVNode(_component_ProfesionalesTablaAsignados, {
                              profesionales: _ctx.profesionalesAsignadosFilas,
                              inicioPrevisto: _ctx.inicioPrevisto,
                              finPrevisto: _ctx.finPrevisto,
                              comarcaId: _ctx.comarcaId
                            }, null, 8, ["profesionales", "inicioPrevisto", "finPrevisto", "comarcaId"])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.busquedaProfesional && _ctx.profesionalesAsignados)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                            _createElementVNode("div", _hoisted_119, [
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("div", _hoisted_121, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.servicioConProfesionalesAsignados.label"
                          )), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary text-uppercase mb-5",
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.busquedaProfesional = true))
                                  }, [
                                    _hoisted_125,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "formularios.servicioDetalle.buscarProfesional.button"
                          )), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.busquedaProfesional && _ctx.profesionalesAsignados)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary text-uppercase mb-5",
                                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.busquedaProfesional = false))
                                  }, [
                                    _hoisted_130,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("formularios.servicioDetalle.volver.button")), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["disabled", "label"])
          ]),
          _: 1
        }, 8, ["onTabClick"])), [
          [_directive_loading, _ctx.cargaDetalle]
        ]),
        _createVNode(_component_ServicioColectivoPicker, { dialogVisible: _ctx.dialogVisible }, null, 8, ["dialogVisible"])
      ]),
      _: 1
    }),
    _createVNode(_component_SendEmailModal, {
      context: _ctx.sendEmailContext,
      onSendEmail: _ctx.onSendEmail
    }, null, 8, ["context", "onSendEmail"])
  ], 64))
}